import React, { useEffect, useMemo, useState } from "react";
import { getContact } from "./Contact.service";
import { decrypt } from "../../utilities/Encriptacion";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Card } from "primereact/card";
import { ProgressSpinner } from "primereact/progressspinner";
import './Contact.style.scss';

interface IContact {
    TIPO: string;
    PUESTO: string;
    NOMBRE: string;
    CORREO: string;
    TELEFONO: string;
}

const getInitials = (name: string) =>
    name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map(word => word[0])
        .join('')
        .toUpperCase();

const Contact: React.FC = () => {
    const [contacts, setContacts] = useState<IContact[]>([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const CLAVE = process.env.REACT_APP_CLAVE_ENCRYPTION;
        const data = decrypt(sessionStorage.getItem('dataClient'), CLAVE);
        const id = JSON.parse(data).id;

        getContact(id, (result: IContact[]) => {
            setContacts(result);
        }).finally(() => setLoading(false));
    }, []);

    const filteredContacts = useMemo(() => contacts.filter(contact =>
        contact.NOMBRE?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        contact.PUESTO?.toLowerCase().includes(searchTerm.toLowerCase())
    ), [contacts, searchTerm]);

    const renderContactCard = (contact: IContact, index: number) => (
        <div key={index} className="contact-card">
            <div className="contact-avatar">{getInitials(contact.NOMBRE)}</div>
            <div className="contact-info">
                <h3>{contact.NOMBRE}</h3>
                {contact.PUESTO && <span className="contact-role">{contact.PUESTO}</span>}
                <div className="contact-actions">
                    {contact.CORREO && (
                        <a href={`mailto:${contact.CORREO}`} title={contact.CORREO}>
                            <i className="pi pi-envelope" /> {contact.CORREO}
                        </a>
                    )}
                    {contact.TELEFONO && (
                        <a href={`tel:${contact.TELEFONO}`} title={contact.TELEFONO}>
                            <i className="pi pi-phone" /> {contact.TELEFONO}
                        </a>
                    )}
                </div>
            </div>
        </div>
    );

    return (
        <div className="contact-container">
            <Card className="contact-card-wrapper">
                <div className="contact-header">
                    <h2><i className="pi pi-address-book" /> Directorio de Contactos</h2>
                    <IconField iconPosition="left" className="contact-search">
                        <InputIcon className="pi pi-search" />
                        <InputText
                            placeholder="Buscar por nombre o puesto..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </IconField>
                </div>

                {loading ? (
                    <div className="contact-loading">
                        <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" />
                        <span>Cargando contactos...</span>
                    </div>
                ) : filteredContacts.length > 0 ? (
                    <div className="contact-grid">
                        {filteredContacts.map(renderContactCard)}
                    </div>
                ) : (
                    <div className="contact-empty">
                        <i className="pi pi-info-circle" />
                        <span>No hay contactos disponibles</span>
                    </div>
                )}
            </Card>
        </div>
    );
};

export default Contact;
